<template>
  <div class="">
    <div class="bot_footer">
      <ul class="list--unstyled clearfix">
        <li>
          {{ COPYRIGHT }}
          <a target="_blank" href="./tpls/license.jpg">营业执照 | </a>
          <span style="margin-left:5px;">
            地址：北京市海淀区奥北科技园领智中心B座5层 |
          </span>
          <span style="margin-right:5px">邮编:100192 </span>
        </li>
        <li>
          <span style="margin-left:5px;margin-right:5px"
            >电话：(010)64845922&nbsp;&nbsp;64846766 |</span
          >
          <span style="margin-left:5px;margin-right:5px"
            >传真：(010)64845989 |</span
          >
          <span style="margin-left:5px;">E-mail:info@terra-it.cn </span>
        </li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      COPYRIGHT: ""
    };
  },
  //方法集合
  methods: {},
  created() {
    this.COPYRIGHT = COPYRIGHT;
  }
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
/* 版心 */
li {
  list-style-type: none;
}
ul {
  margin: 0;
  padding: 0;
}
.w {
  width: 1190px;
  margin: 0 auto;
}
.bot_footer {
  box-sizing: border-box;
  background-color: #021325;
  a {
    text-decoration: none;
    color: #fff;
    font-size: 12px;
  }
  ul {
    box-sizing: border-box;
    padding-bottom: 10px;
    padding-top: 10px;
    margin: 0;
    li {
      color: #fff;
      font-size: 12px;
      // float: left;
      text-align: center;
    }
  }
}
</style>
